import ChallengeList from '@/src/components/challenges/ChallengeList';
import React from 'react';

export const ChallengesPage: React.FC = () => {
  return <ChallengeList />;
};
